import { GetCampaignModel } from "@factory/model/query-model-campaign";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { campaignFormDefault } from "./form.default";
import { CampaignFormSchema } from "./form.rule";

export const useFormDefaultCampaign = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetCampaignModel | undefined) => {
    return !cachedValue
      ? campaignFormDefault
      : ({
          tenant: cachedValue.tenant,
          level: cachedValue.level,
          name: cachedValue.name,
          description: cachedValue.description,
          image: cachedValue.image,
          points: cachedValue.points,
          stamp: cachedValue.stamp,
          redeemByPoints: Boolean(cachedValue.redeem_by_points),
          redeemByStamp: Boolean(cachedValue.redeem_by_stamp),
          multiRedeem: Boolean(cachedValue.multi_redeem),
          redeemLimit: cachedValue.redeem_limit,
          startDate: formatDate(cachedValue.start_date) as any,
          endDate: formatDate(cachedValue.end_date) as any,
          constraint: cachedValue.constraint,
          limitPerMonth: cachedValue.limit_per_month,
          forBirthday: Boolean(cachedValue.for_birthday), 
          birthdayWindowDays: cachedValue.birthday_window_days,
        } as CampaignFormSchema);
  };

  return {
    getDefault,
  };
};
